import React from 'react'
import Header from '../../Components/Header'
import BucketCart from './BucketCart'
import GuestLogin from './GuestLogin'

export default function GuestDetails() {
    return (
        <>
            <Header />
            <div className='container-xxl category-container-custom mt-120 mb-md-100'>
                <div className="row">
                    <div className="col-lg-8">
                        <GuestLogin />
                    </div>
                    <div className="col-lg-4">
                        <BucketCart />
                    </div>
                </div>
            </div>
        </>
    )
}
